import React from "react";

const CandleStickIcon = ({ className = "" }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 4v20" stroke="#EF4444" strokeWidth="1" />
      <path d="M16 4v20" stroke="#22C55E" strokeWidth="1" />
      <rect x="6" y="8" width="4" height="12" rx="1" fill="#EF4444" />
      <rect x="14" y="10" width="4" height="10" rx="1" fill="#22C55E" />
    </svg>
  );

export default CandleStickIcon; 